import '../styles/fields.css'
import { Link } from 'react-router-dom'
import React, { useEffect, useState } from 'react';
import HeaderFFF from '../components/HeaderFFF'
import Header from '../components/Header'
import Footer from '../components/Footer'


export default function Fields() {

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 991);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return(
        <>
        {isMobile ? <Header /> : <HeaderFFF />}
            <div id="fields-header-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <h2>Fields of Expertise</h2>
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
            <div id="fields-container">
                {/* FIELD 1 */}
                <div className="field-box">
                    <img src="./img/fields/corp.png" alt="Laptops and documents on a meeting table."></img>
                    <div className="field-text">
                        <h3>Corporate & Commercial Law</h3>
                        <svg xmlns="http://www.w3.org/2000/svg" width="353" height="2" viewBox="0 0 353 2" fill="none">
                            <path d="M0 1H353" stroke="#BF9874"/>
                        </svg>
                        <p>A solid legal structure is crucial for business success, and consulting a lawyer proactively can help entrepreneurs avoid many common legal issues and lay the groundwork for long-term stability.</p>
                        <button className="field-btn"><Link to="corporate-and-commercial-law">LEARN MORE</Link></button>
                    </div>
                </div>
                {/* FIELD 2 */}
                <div className="field-box">
                    <img src="./img/fields/litigation.png" alt="Laptops and documents on a meeting table."></img>
                    <div className="field-text">
                        <h3>Litigation</h3>
                        <svg xmlns="http://www.w3.org/2000/svg" width="353" height="2" viewBox="0 0 353 2" fill="none">
                            <path d="M0 1H353" stroke="#BF9874"/>
                        </svg>
                        <p style={{paddingBottom: '75px'}}>Our litigation department handles a broad range of litigation for corporations, partnerships and other entities as well as individuals in a wide variety of matters.</p>
                        <button className="field-btn"><Link to="litigation">LEARN MORE</Link></button>
                    </div>
                </div>
                {/* FIELD 3 */}
                <div className="field-box">
                    <img src="./img/fields/injury.png" alt="Laptops and documents on a meeting table."></img>
                    <div className="field-text">
                        <h3>Personal Injury</h3>
                        <svg xmlns="http://www.w3.org/2000/svg" width="353" height="2" viewBox="0 0 353 2" fill="none">
                            <path d="M0 1H353" stroke="#BF9874"/>
                        </svg>
                        <p>Our personal injury department has a lot to offer if you are looking for a personal injury law firm specializing in a wide range of practices. Our experienced injury lawyers ensure you receive fulfilling professional assistance for the following law services in the GTA and surrounding locations.</p>
                        <button className="field-btn"><Link to="personal-injury">LEARN MORE</Link></button>
                    </div>
                </div>
                {/* FIELD 4 */}
                <div className="field-box">
                    <img src="./img/fields/realestate.png" alt="Laptops and documents on a meeting table."></img>
                    <div className="field-text">
                        <h3>Real Estate</h3>
                        <svg xmlns="http://www.w3.org/2000/svg" width="353" height="2" viewBox="0 0 353 2" fill="none">
                            <path d="M0 1H353" stroke="#BF9874"/>
                        </svg>
                        <p>We provide comprehensive counsel for real estate developments, guiding clients through financing, construction, leasing, and management while conducting due diligence and managing all legal aspects to ensure successful transactions and project outcomes.</p>
                        <button className="field-btn"><Link to="real-estate">LEARN MORE</Link></button>
                    </div>
                </div>
            </div>

        <Footer/>
        </>
    );
}